/**
 * 销售业绩成本/毛利核算可见角色：超管、管理员、财务
 */
export function canViewSaleCostProfit(userRole) {
  return ['super_admin', 'admin', 'finance'].includes(userRole)
}
